import axios from "axios";
import * as logs from "./logs";
import qz from "../../printer";

const state = {
  licence: "",
  isOffline: false,
  forceOffline: false,
  terminal_id: "",
  weightPort: "",
  store_id: "",
  is_catalog: 0,
  trans_from: "CLOUD_TAB_WEB",
  device_name: "",
  theme: "theme-light",
  paymentDeviceDetails: "",
  settings: {},
  last_setting_invoked: "",
  printer: "",
  mp200Port: "",
  country_details: {},
  product_search_is_offline: 1,
  scan_only_mode: false,
  payment_integrations: {
    phonepe: {
      transaction_id: "",
    },
  },
  socket_connect: true,
  socket_data_sync: false,
  plu_data: {
    status: false,
    delimiter: "",
    // unit: "",
    format: "",
  },
};

const getters = {
  checkLicence: (state) => !!state.licence,
  isOffline: (state) => !!state.isOffline,
  isOfflineEnabled: (state) => {
    let check = false;
    if (
      state.settings.hasOwnProperty("vendor_app_menu") &&
      state.settings.vendor_app_menu.hasOwnProperty("offline") &&
      state.settings.vendor_app_menu.offline.status == 1
    )
      check = true;
    else check = false;
    return check;
  },
  currencySymbol: (state) => {
    let symbol = "";
    if (state.settings.vendor_login_details.hasOwnProperty("currency"))
      symbol = state.settings.vendor_login_details.currency.symbol;
    else symbol = "₹";

    return symbol + " ";
  },
  billLogo: (state) => {
    return {
      data: [
        {
          type: "raw",
          format: "image",
          flavor: "base64",
          data: state.settings.bill_logo.header_logo.base64,
          options: {
            language: "ESCPOS",
            dotDensity: "double",
          },
        },
      ],
      config: qz.configs.create(state.printer, {
        size: {
          height: state.settings.bill_logo.header_logo.height,
          width: state.settings.bill_logo.header_logo.width,
        },
        units: state.settings.bill_logo.header_logo.units,
      }),
      img:
        "<center><img class='mb-1' width='150' height='auto' src='" +
        state.settings.bill_logo.header_logo.base64 +
        "'></center>",
    };
  },
  qrCode: (state, getters, rootState) => {
    let qr = JSON.stringify(
      Object.assign(
        {
          amount: rootState.billing.billing.invoice_details.amount,
          invoice_no: rootState.billing.billing.invoice_details.invoice_no,
        },
        state.settings.store_account_details
      )
    );
    let dots = "\x03";
    let qrLength = qr.length + 3;
    let size1 = String.fromCharCode(qrLength % 256);
    let size0 = String.fromCharCode(Math.floor(qrLength / 256));
    let qrBase64 = "";
    var QRCode = require("qrcode");

    QRCode.toDataURL(qr, function(err, url) {
      qrBase64 = url;
    });

    return {
      qrImg:
        "<center><img class='mb-1' width='150' height='auto' src='" +
        qrBase64 +
        "'></center>",
      config: qz.configs.create(state.printer, {
        encoding: "ISO-8859-1",
      }),
      print: state.settings.store_account_details.status,
      data: [
        "\x1D" +
          "\x28" +
          "\x6B" +
          "\x04" +
          "\x00" +
          "\x31" +
          "\x41" +
          "\x32" +
          "\x00",
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x43" + dots,
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x45" + "\x30",
        "\x1D" +
          "\x28" +
          "\x6B" +
          size1 +
          size0 +
          "\x31" +
          "\x50" +
          "\x30" +
          qr,
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x51" + "\x30",
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x52" + "\x30",
        "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A",
        "\x1B" + "\x69",
      ],
    };
  },
  salesPersonActive: (state) => {
    let check = false;
    state.settings.cart_menu.map((item) => {
      if (item.name == "assign_salesman" && item.status == 1) check = true;
    });
    return check;
  },
  getRefundType: (state) => {
    let type = { cash: false, store_credit: false };
    let options = state.settings.cart.allow_adhoc_return.options[0];
    type.cash = options.cash.status == 1 ? true : false;
    type.store_credit =
      options.store_credit_note.status == 1
        ? true
        : options.cash.status == 0
        ? true
        : false;
    return type;
  },
};

const mutations = {
  changeSearchMode(state, data) {
    state.product_search_is_offline = data;
  },
  socketDataSyncStatus(state, data) {
    state.socket_data_sync = data;
  },
  setSocketConnection(state, data) {
    state.socket_connect = data;
  },
  setPhonepeTransactionId(state, data) {
    state.payment_integrations.phonepe.transaction_id = data;
  },
  clearPhonepeTransactionId(state) {
    state.payment_integrations.phonepe.transaction_id = "";
  },
  forceOfflineStatus(state, data) {
    state.forceOffline = data;
  },
  getProductSearchStatus(state, data) {
    state.product_search_is_offline = data;
  },
  getCountryDetails(state, data) {
    state.country_details = data;
  },
  setLicense(state, data) {
    state.licence = data.udidtoken;
  },
  setConnected(state, data) {
    state.isOffline = data;
  },
  setFeatures(state, data) {
    data.vendor_app_menu.main_menu.map((item) => {
      if (item.name == "shop_by_catalog" || item.name == "start_billing") {
        state.is_catalog = item.status;
      }
    });
  },
  getSettings(state, data) {
    state.settings = data;
  },
  saveWeightPort(state, data) {
    state.weightPort = data;
  },
  setTheme(state, data) {
    state.theme = data;
  },
  setDefaultPrinter(state, data) {
    state.printer = data;
  },
  saveMp200Port(state, data) {
    state.mp200Port = data;
  },
  setInvoiceOrderId(state, data) {
    state.settings.vendor_app_menu.offline.offline_invoice_id_format.order_id.name = data;
  },
  setPluData(state, data) {
    state.plu_data.status = true;
    state.plu_data.delimiter = data.delimiter;
    // state.plu_data.unit = data.unit;
    state.plu_data.format = data.format;
  },
  clearPluData(state) {
    state.plu_data.status = false;
    state.plu_data.delimiter = "";
    // state.plu_data.unit = "";
    state.plu_data.format = "";
  },
  setScanOnlyMode(state, data) {
    state.scan_only_mode = data;
  },
  offlineUpdateDummyCustomerId(state, data) {
    state.settings.vendor_login_details.c_id = data;
  },
};

const actions = {
  getLatestSettings({ state, commit, dispatch, getters }) {
    return new Promise((resolve, reject) => {
      axios
        .post("/vendor/get-settings", {
          v_id: this.state.sessions.user.v_id,
          trans_from: this.state.system.trans_from,
          api_token: this.state.sessions.user.api_token,
          vu_id: this.state.sessions.user.id,
          store_id: this.state.sessions.user.store_id,
          mobile: this.state.sessions.user.mobile,
          terminal_id: this.state.system.settings.terminal_id,
          url: "/vendor/get-settings",
        })
        .then((res) => {
          commit("billing/setDummyCustomer", res.data.settings, {
            root: true,
          });
          // dispatch('getSessionDetails');
          commit("sessions/setSessionDetails", res.data.settings, {
            root: true,
          });
          commit("setFeatures", res.data.settings);
          commit("getSettings", res.data.settings);
          if (!state.isOffline) {
            if (getters.salesPersonActive)
              dispatch("billing/getSalesPersonList", null, { root: true });
            dispatch("offline/saveOfflineDummyCustomer", null, { root: true });
          }
          //   commit("settingReovkedDate");
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSettings(state, data) {
    state.settings = data;
  },
  setUpPaymentDevice(state, data) {
    state.paymentDeviceDetails = data;
  },
  saveDeviceInfo(state, data) {
    state.device_name = data;
  },
  updateVendorProfile({ commit }, data) {
    return Promise((resolve) => {
      commit("updateProfile", data);
      resolve(data);
    });
  },
  changeTheme({ commit }, data) {
    commit("setTheme", data);
  },
  log({}, data) {
    logs.log(data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
